import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./components/LandingPage.jsx";
import BlogPostPage from "./components/BlogPostPage.jsx";
import PrivacyPolicyPage from "./components/PrivacyPolicyPage.jsx";
import HolomPage from "./components/HolomPage.jsx";
import CookieBanner from "./components/CookieBanner.jsx";
import { Toaster } from "./components/ui/toaster.jsx";
import { I18nProvider } from "./i18n/I18nContext.jsx";

function App() {
  return (
    <I18nProvider>
      <div className="min-h-screen bg-background text-foreground">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/holom" element={<HolomPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
        <Toaster />
      </div>
    </I18nProvider>
  );
}

export default App;
